import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ReactGA from "react-ga4";

export const BookRideButton: React.FC<{ isMobile?: boolean }> = ({ isMobile = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    ReactGA.event({
      category: "User Interaction",
      action: `Clicked Book a Ride ${isMobile ? 'Mobile' : 'Side'}button`,
    });
    navigate('/book');
  };

  if (isMobile) {
    return (
      <button
        className="fixed bottom-0 left-0 right-0 bg-[#EC6707] hover:bg-[#d55a06] text-white font-bold py-3 px-4 z-50 transition-all duration-300"
        onClick={handleClick}
        id='mobile-book-ride-btn'
      >
        {t('BookRideNow')}
      </button>
    );
  }

  return (
    <div className="flex items-center justify-end mt-8">
      <div className="w-2 h-2 bg-white rounded-full mr-2"></div>
      <button
        className="bg-[#EC6707] hover:bg-[#d55a06] text-white font-bold py-2 px-4 rounded-md shadow-lg z-50 transition-all duration-300 hover:scale-105"
        onClick={handleClick}
        id='fixed-book-ride-btn'
      >
        {t('BookRideNow')}
      </button>
    </div>
  );
};